The optional hiring organization for whom the relationship was changed.

This field is only accessible while you have an active relationship with the hirer.
If all relationships have been removed, it will return null along with a `FORBIDDEN` error.
